
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class NbTableAction extends Vue {
  @Prop({ type: String }) readonly type?: "error";
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

  get classes() {
    return {
      "nb-table__action--error": this.type === "error",
      "nb-table__action--disabled": this.disabled,
    };
  }

  onClick(e: MouseEvent) {
    if (this.disabled) return;

    if (e) e.stopPropagation();

    this.$emit("click", e);
  }
}
